import { render, staticRenderFns } from "./Payslips.vue?vue&type=template&id=1fb3d086&scoped=true&"
import script from "./Payslips.vue?vue&type=script&lang=js&"
export * from "./Payslips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb3d086",
  null
  
)

export default component.exports